import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-74e14f10"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-container"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "main-name"
}, "学期课表"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub-name"
}, "2024学年第一学期")], -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview-wrapper"
}, null, -1));

export default {
  props: {
    show: Boolean
  },
  emits: ['update:show'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const weekList = [{
      week: 0,
      courses: [{
        index: 1,
        startTime: "08:00",
        //开始时间
        endTime: "09:30",
        //结束时间
        subject: "高等数学",
        //学科
        major: "计算机科学与技术",
        //专业
        class: "1702班" //班级

      }, {
        index: 3,
        startTime: "08:00",
        //开始时间
        endTime: "09:30",
        //结束时间
        subject: "语文",
        //学科
        major: "计算机科学与技术",
        //专业
        class: "1702班" //班级

      }]
    }];
    const colorList = ["#4BBDEE", "#E86EEB", "#4BBDEE", "#13DAC2", "#7464FB", "#F18141", "#57C946", "#E8BE2A", "#508AFA"];

    const handleClose = () => {
      emit('update:show', false);
    };

    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(show) ? show.value = $event : null),
        width: "1000px",
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};